import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import EventOverview from './components/EventOverview';
import Leaderboard from './components/Leaderboard';
import ParticipationGuide from './components/ParticipationGuide';
import EventRewards from './components/EventRewards';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A1628]">
      <Hero scrolled={scrolled} />
      <EventOverview />
      <Leaderboard />
      <ParticipationGuide />
      <EventRewards />
      <Footer />
    </div>
  );
}
